module.exports = __webpack_public_path__ + "static/media/8-dragons.b52f28d7.gif";